import { Action } from 'redux';
// Import States.
import {
	AppState,
	BroadLineOfBusinessState,
	PossiblePerilsState,
	getInitialPossiblePerilsState,
} from '@app/redux/states';
// Import Actions.
import {
	LoadPossiblePerilsAction,
	PossiblePerilAction,
} from '@app/redux/actions';
// Import state initializers.
import {
	initializeBroadLineOfBusinessState,
} from '@app/redux/reducers/initializers';
// Import state queries.
import {
	queryBroadLineOfBusinessState,
} from '@app/redux/reducers/queries';
// Import api models.
import {
	PossiblePeril,
} from '@app/models/api';


/**
 * This handles initializing the state.
 * @param state
 * @param action
 */
let initializeState = (state: AppState, action: PossiblePerilAction): AppState => {
	let newState: AppState = { ...state };
	// Initialize the parent state.
	newState = initializeBroadLineOfBusinessState(newState, action);
	// Query the parent state.
	let broadLineOfBusinessState: BroadLineOfBusinessState = queryBroadLineOfBusinessState(newState, action);
	let stateCode: string = action.stateCode;
	// Initialize the state.
	if (!broadLineOfBusinessState.possiblePerils[stateCode] === undefined) {
		broadLineOfBusinessState.possiblePerils[stateCode] = getInitialPossiblePerilsState();
	}
	else {
		broadLineOfBusinessState.possiblePerils[stateCode] = { ...broadLineOfBusinessState.possiblePerils[stateCode] };
	}
	return newState;
}

/**
 * Query the state.
 * @param state
 * @param action
 */
let queryPossiblePerilsState = (state: AppState, action: PossiblePerilAction): PossiblePerilsState => {
	let stateCode: string = action.stateCode;
	return queryBroadLineOfBusinessState(state, action).possiblePerils[stateCode];
}


// Load Possible Perils Reducer.

let LoadPossiblePerilsReducer = (state: AppState, action: Action): AppState => {
	let loadPossiblePerilsAction: LoadPossiblePerilsAction = action as LoadPossiblePerilsAction;
	let possiblePerils: PossiblePeril[] = loadPossiblePerilsAction.possiblePerils;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state, loadPossiblePerilsAction);

	// Query the state.
	let possiblePerilsState: PossiblePerilsState = queryPossiblePerilsState(newState, loadPossiblePerilsAction);

	possiblePerilsState.possiblePerils = possiblePerils;
	possiblePerilsState.arePossiblePerilsLoaded = true;

	return newState;
}

// Export reducers.
export {
	LoadPossiblePerilsReducer,
};

// Export initializers.
export {
	initializeState
}

// Export queries.
export {
	queryPossiblePerilsState
};